var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorDisplay)?_c('div',{staticClass:"error"},[_c('div',{staticClass:"error-close icon-otw_icon_arrow_close2",on:{"click":_vm.closeError}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMsg)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }